import type { RunStatus } from "@/api/types";

export interface StatusMeta {
  label: string;
  /** solid dot / accent color */
  dot: string;
  /** text color */
  text: string;
  /** tinted pill: bg + text + ring */
  badge: string;
  /** raw CSS color var, for charts / inline styles */
  color: string;
  /** actively-executing state → drives the live pulse */
  live: boolean;
}

// Static class strings (not interpolated) so Tailwind's scanner keeps them.
// Color keys map to CSS vars via @theme: --color-ok/run/wait/pause/fail/idle.
export const STATUS: Record<RunStatus, StatusMeta> = {
  completed: {
    label: "completed",
    dot: "bg-ok",
    text: "text-ok",
    badge: "bg-ok/10 text-ok ring-1 ring-inset ring-ok/25",
    color: "var(--st-ok)",
    live: false,
  },
  running: {
    label: "running",
    dot: "bg-run",
    text: "text-run",
    badge: "bg-run/10 text-run ring-1 ring-inset ring-run/25",
    color: "var(--st-run)",
    live: true,
  },
  waiting: {
    label: "waiting",
    dot: "bg-pause",
    text: "text-pause",
    badge: "bg-pause/10 text-pause ring-1 ring-inset ring-pause/25",
    color: "var(--st-pause)",
    live: true,
  },
  pending: {
    label: "pending",
    dot: "bg-wait",
    text: "text-wait",
    badge: "bg-wait/10 text-wait ring-1 ring-inset ring-wait/25",
    color: "var(--st-wait)",
    live: true,
  },
  failed: {
    label: "failed",
    dot: "bg-fail",
    text: "text-fail",
    badge: "bg-fail/10 text-fail ring-1 ring-inset ring-fail/25",
    color: "var(--st-fail)",
    live: false,
  },
  cancelled: {
    label: "cancelled",
    dot: "bg-idle",
    text: "text-idle",
    badge: "bg-idle/10 text-idle ring-1 ring-inset ring-idle/25",
    color: "var(--st-idle)",
    live: false,
  },
};
